module.exports = __webpack_public_path__ + "static/media/attach_file.d248e976.svg";